import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isManageInvitationKeysPanelOpenSelector,
  isUpdatingInvitationKeysSelector,
  setIsManageInvitationKeysPanelOpen,
  updateInvitationKeys,
} from '../../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import { noSelectionKey } from '../../../../../../../utilities/filterAndSortingsUtil';
import {
  getEntityId,
  getRelId,
} from '../../../../../../../features/helpers/apiHelpers';
import {
  INVITATIONGROUP_TYPE,
  INVITATIONKEY_TYPE,
} from '../../../../../../../constants/api';

export const useManageInvitationKeys = (
  selectedInvitationGroupKey,
  allInvitationGroups,
  allInvitationKeys,
) => {
  const dispatch = useDispatch();
  const isPanelOpen = useSelector(isManageInvitationKeysPanelOpenSelector);
  const isUpdating = useSelector(isUpdatingInvitationKeysSelector);

  const currentInvitationKeys = useMemo(() => {
    if (!allInvitationKeys || selectedInvitationGroupKey === noSelectionKey) {
      return [];
    }
    return allInvitationKeys.filter(
      (invitationKey) =>
        getRelId(invitationKey, INVITATIONGROUP_TYPE) ===
        selectedInvitationGroupKey,
    );
  }, [allInvitationKeys, selectedInvitationGroupKey]);

  const [keys, setKeys] = useState([]);
  const [cprValue, setCprValue] = useState('');
  const [cvrValue, setCvrValue] = useState('');
  const [emailValue, setEmailValue] = useState('');

  const selectedGroup = useMemo(() => {
    return allInvitationGroups?.find(
      (group) => getEntityId(group) === selectedInvitationGroupKey,
    );
  }, [allInvitationGroups, selectedInvitationGroupKey]);

  useEffect(() => {
    if (isPanelOpen && selectedInvitationGroupKey !== noSelectionKey) {
      setKeys([...currentInvitationKeys]);
      setCprValue('');
      setCvrValue('');
      setEmailValue('');
    }
  }, [isPanelOpen, selectedInvitationGroupKey, currentInvitationKeys]);

  function onPanelClose() {
    dispatch(setIsManageInvitationKeysPanelOpen(false));

    setKeys([]);
    setCprValue('');
    setCvrValue('');
    setEmailValue('');
  }

  function onAddKey() {
    const newKey = {
      attributes: {
        cpr: cprValue.trim() || undefined,
        cvr: cvrValue.trim() || undefined,
        email: emailValue.trim() || undefined,
      },
      type: INVITATIONKEY_TYPE,
    };

    setKeys((prev) => [...prev, newKey]);

    setCprValue('');
    setCvrValue('');
    setEmailValue('');
  }

  function onRemoveKey(keyToRemove) {
    setKeys((prev) => prev.filter((key) => key !== keyToRemove));
  }

  function onSaveChanges() {
    dispatch(
      updateInvitationKeys({
        invitationGroupId: selectedInvitationGroupKey,
        invitationKeys: keys,
      }),
    );
  }

  return {
    keys,
    cprValue,
    setCprValue,
    cvrValue,
    setCvrValue,
    emailValue,
    setEmailValue,
    isPanelOpen,
    selectedGroup,
    onPanelClose,
    onAddKey,
    onRemoveKey,
    onSaveChanges,
    isUpdating,
  };
};
